<!-- <fa-icon [icon]="faPlay" class="position-absolute text-white" style="left: 50%; top: 50%; transform: translate(-50%, -50%)" *ngIf="!isplaying" ></fa-icon> -->
<img class="img-fluid" [src]="thumbnail" *ngIf="!isplaying" />
<video class="img-fluid"  *ngIf="isplaying" [src]="srcmp4" type="video/mp4" controls>
</video>
